var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorefrontIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 60,
    viewBox: "0 0 68 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M67 19.6333L62.3 0H49.8H43.1H37.3334H30.6667H24.9334H18.2H5.70002L1.00002 19.6333C0.200022 23.0333 0.933356 26.5 3.06669 29.2333C3.33336 29.6 3.70002 29.8667 4.00002 30.2V60H64V30.2C64.3 29.9 64.6667 29.6 64.9334 29.2667C67.0667 26.5333 67.8334 23.0333 67 19.6333ZM17.4 6.66667L15.4667 22.8667C15.2 25.0333 13.4667 26.6667 11.4334 26.6667C9.80002 26.6667 8.76669 25.7 8.33336 25.1C7.46669 24 7.16669 22.5667 7.50002 21.2L10.9667 6.66667H17.4ZM57.0334 6.66667L60.5334 21.2C60.8667 22.6 60.5667 24 59.7 25.1C59.2334 25.7 58.2334 26.6667 56.5667 26.6667C54.5334 26.6667 52.7667 25.0333 52.5334 22.8667L50.6 6.66667H57.0334ZM45.7 21.7333C45.8667 23.0333 45.4667 24.3333 44.6 25.3C43.8334 26.1667 42.7667 26.6667 41.4 26.6667C39.1667 26.6667 37.3334 24.7 37.3334 22.3V6.66667H43.8667L45.7 21.7333ZM30.6667 22.3C30.6667 24.7 28.8334 26.6667 26.3667 26.6667C25.2334 26.6667 24.2 26.1667 23.4 25.3C22.5667 24.3333 22.1667 23.0333 22.3 21.7333L24.1334 6.66667H30.6667V22.3ZM10.6667 53.3333V33.2333C10.9334 33.2667 11.1667 33.3333 11.4334 33.3333C14.3334 33.3333 16.9667 32.1333 18.9 30.1667C20.9 32.1667 23.5667 33.3333 26.6 33.3333C29.5 33.3333 32.1 32.1333 34.0334 30.2333C36 32.1333 38.6667 33.3333 41.6667 33.3333C44.4667 33.3333 47.1334 32.1667 49.1334 30.1667C51.0667 32.1333 53.7 33.3333 56.6 33.3333C56.8667 33.3333 57.1 33.2667 57.3667 33.2333V53.3333H10.6667Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorefrontIcon);
export default __webpack_public_path__ + "static/media/StorefrontIcon.1edc723f1084673deb236ff3cd972f0d.svg";
export { ForwardRef as ReactComponent };